import { RouterProvider, createBrowserRouter, ScrollRestoration } from 'react-router-dom'; // ScrollRestoration اضافه شد
import './App.css';
import MainPage from './routes/MainPage';
import NotFound from './routes/NotFound';
import Layout from './components/layout/Layout';
import AbouUsPage from './routes/AboutUsPage';
import ContactUsPage from './routes/ContactUsPage';
import DoctorProfilePage from './routes/DoctorProfilePage';
import DoctorsListPage from './routes/DoctorsListPage';
import MedicalCentersListPage from './routes/medicalCentersListPage';
import MedicalCenterDetail from './routes/medicalCenterDetail';

const router = createBrowserRouter([
  {
    element: (
      <>
        <ScrollRestoration />
        <Layout />
      </>
    ),
    children: [
      { path: '/', element: <MainPage /> },
      { path: 'aboutus', element: <AbouUsPage /> },
      { path: 'contactus', element: <ContactUsPage /> },
      { path: 'doctors', element: <DoctorsListPage/> },
      { path: 'centers', element: <MedicalCentersListPage/> },
      { path: "/center/:id", element: <MedicalCenterDetail/> },
      { path: 'doctor/:id', element: <DoctorProfilePage/> },
    ],
  },
  { path: '*', element: <NotFound/> },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
